import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalHeader,
  Spinner,
  VStack,
  Text,
  Progress,
  Box,
  useBreakpointValue,
} from "@chakra-ui/react";

type GaraazLoadingModalProps = {
  isOpen: boolean;
  title?: string;
  message?: string;
  showProgress?: boolean;
  progressValue?: number;
};

const GaraazLoadingModal: React.FC<GaraazLoadingModalProps> = ({
  isOpen,
  title = "Please wait",
  message = "Processing...",
  showProgress = false,
  progressValue = 0,
}) => {
  const modalWidth = useBreakpointValue({ base: "90%", md: "480px" });

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {}}
      isCentered
      closeOnOverlayClick={false}
      closeOnEsc={false}
      trapFocus
      motionPreset="scale"
      blockScrollOnMount
    >
      <ModalOverlay />
      <ModalContent width={modalWidth} pointerEvents="auto">
        {/* Don't render ModalCloseButton */}
        <ModalHeader>{title}</ModalHeader>
        <ModalBody>
          <VStack spacing={4} align="center" pb={2}>
            <Spinner size="xl" thickness="4px" />
            <Text textAlign="center">{message}</Text>

            {showProgress && (
              <Box width="100%" pt={2}>
                <Progress value={Math.max(0, Math.min(100, progressValue))} />
                <Text fontSize="sm" textAlign="right" pt={1}>
                  {Math.round(Math.max(0, Math.min(100, progressValue)))}%
                </Text>
              </Box>
            )}
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default GaraazLoadingModal;
